export const guardarObjLocal = ({key, obj}) => {

    let objString = JSON.stringify(obj)

    window.localStorage.setItem(key, objString)

}